// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__FXUcu","error":"Textarea_error__3EObH","readonly":"Textarea_readonly__pKle_","disabled":"Textarea_disabled__2dwqD"};